<template>
    <div class="container">

        <div class="messaging">

            <div class="inbox_msg" style="margin-top: 25px;">
                <div class="card card-header">
                    
                    <span class="text-black" style="font-size: 14px; line-height: 16px">
                        Soran: <b>{{kelime.yazan}}</b>
                        <br>
                        Güncelleme: <b>{{formatDate(kelime.guncellemeTarihi)}}</b>                  
                        <br>
                        Mesaj Sayısı: <b-badge style="font-size:15px">{{kelime.mesajlar.filter((mesaj)=> mesaj.kisiId !== kelime.kisiId).length}}</b-badge>
                    </span>

                </div>
                <div class="w-100" style="display: flex;justify-content: center;">
                    <div class="w-100">
                        <div>
                            <img class="w-100" style="cursor: pointer; display: block; margin: auto;"
                                 @click="kirp=!kirp" :src="resmiGetir(kelime.resim)" alt=""/>
                        </div>
                    </div>
                </div>

                <div class="mesgs">
                    <div ref="msgHistory" class="msg_history">
                        <!--
                        
                                                <b-badge class="w-100" variant="info">Toplam {{kelime.mesajlar.length}} Mesajdan 3'ü
                                                    Gösteriliyor.
                                                </b-badge>
                        -->

                        <div v-for="(message, index) in msjlar" :key="index">
                            <div v-if="message.kisiId !== kelime.kisiId" class="incoming_msg">
                                <div class="received_msg">
                                    <div class="received_withd_msg">
                                        <p>
                                            <span style="font-size:10px; font-family: 'Times New Roman'; font-weight: bold">{{message.yazan}}</span><br>{{message.mesaj}}
                                        </p>
                                        <span class="time_date"
                                              style="padding-left: 13px; float:right">{{formatDate(message.tarih)}}</span>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <div class="outgoing_msg">
                                    <div class="sent_msg">
                                        <p>
                                            <span style="font-size:10px; font-family: 'Times New Roman'; font-weight: bold">{{message.yazan}}</span><br>{{message.mesaj}}
                                        </p>
                                        <span class="time_date"
                                              style="float:right"> {{formatDate(message.tarih)}}</span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="mesajYazGoster" class="inbox_msg" style="margin-top: 20px;">
                        <div class="mesgs">
                            <div class="type_msg">
                                <div class="input_msg_write">
                                    <input @keyup.enter="sendMessage" v-model="newMessage" class="write_msg"
                                           placeholder="Mesaj Yazın..."/>
                                    <button @click="sendMessage" class="msg_send_btn">
                                        <b-icon icon="cursor-fill"></b-icon>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {okunmayanKMesajEkle} from "@/api/okunamayan"
    import moment from "moment"
    import {mapGetters} from "vuex"

    export default {
        name: 'OkunmayanKelime',
        props: {
            kelime: {},
            mesajYazGoster: {
                type: Boolean,
                default: true
            },
            filtreKod: {
                type: String,
                default: ''
            }
        },
        watch: {
            msjlar: {
                immediate: true,
                handler(yeni) {
                    if (yeni) {
                        this.scrollToBottom()
                    }
                }
            }
        },
        data() {
            return {
                msjlar: this.kelime.mesajlar,
                newMessage: '',
                kirp: true,
            }
        },
        computed: {
            ...mapGetters([
                'kisi'
            ]),
        },
        methods: {
            resmiGetir(guid) {
                return process.env.VUE_APP_BASE_API_URL + "OkunamayanKelime/ResimGetir?guid=" + guid + "&kirp=" + this.kirp;
            },
            scrollToBottom() {
                this.$nextTick(() => {
                    const container = document.querySelector('.msg_history');
                    container.scrollTop = container.scrollHeight;
                })
            },
            async sendMessage() {
                if (!this.newMessage)
                    return;

                const res = await okunmayanKMesajEkle(this.kelime.kelimeId, this.newMessage);
                if (res.hataVarMi) {
                    return
                }
                this.newMessage = '';
            },
            formatDate(date) {
                return moment(date).format('Do MMMM HH:mm')
            }
        }
    }
</script>

<style scoped lang="scss">
    .messaging {
        padding: 0 0 50px 0;
        @media (max-width: 500px) {
            height: 30%;
        }
    }

    .inbox_msg {
        border: 1px solid #c4c4c4;
        clear: both;
        overflow: hidden;
    }

    .top_spac {
        margin: 20px 0 0;
    }

    .chat_ib h5 {
        font-size: 15px;
        color: #464646;
        margin: 0 0 8px 0;
    }

    .chat_ib h5 span {
        font-size: 13px;
        float: right;
    }

    .chat_ib p {
        font-size: 14px;
        color: #989898;
        margin: auto
    }


    .incoming_msg_img {
        display: inline-block;
        width: 6%;
    }

    .received_msg {
        display: inline-block;
        vertical-align: top;
        width: 100%;
        margin: 13px 0 13px;
    }

    .received_withd_msg p {
        background: #cdcdcd none repeat scroll 0 0;
        border-radius: 15px;
        color: rgba(0, 0, 0, 0.98);
        font-size: 14px;
        margin: 0;
        padding: 5px 10px 5px 12px;
        width: 100%;
    }

    .time_date {
        color: #000000;
        display: block;
        font-size: 12px;
        margin: 3px 0 0;
    }

    @media screen and (max-width: 768px) {
        .received_withd_msg {
            width: 100%;
        }
    }

    @media screen and (min-width: 768px) {
        .received_withd_msg {
            width: 57%;
        }
    }

    .mesgs {
        //float: left;
        //padding: 0px 15px 0 25px;
        width: 100%;
        padding: 5px;
    }

    .sent_msg p {
        background: #6c757d none repeat scroll 0 0;
        border-radius: 15px;
        font-size: 14px;
        margin: 0;
        color: #fff;
        padding: 5px 10px 5px 12px;
        width: 100%;
    }

    .outgoing_msg {
        overflow: hidden;
        margin: 26px 0 26px;
    }

    @media screen and (max-width: 768px) {
        .sent_msg {
            float: right;
            width: 100%;
        }
    }

    @media screen and (min-width: 768px) {
        .sent_msg {
            float: right;
            width: 46%;
        }
    }


    .input_msg_write input {
        background: rgba(0, 0, 0, 0) none repeat scroll 0 0;
        border: medium none;
        color: #4c4c4c;
        font-size: 15px;
        min-height: 48px;
        width: 100%;
    }

    .type_msg {
        border-top: 1px solid #c4c4c4;
        position: relative;
    }

    .msg_send_btn {
        background: #05728f none repeat scroll 0 0;
        border: medium none;
        border-radius: 50%;
        color: #fff;
        cursor: pointer;
        font-size: 20px;
        height: 33px;
        position: absolute;
        right: 10px;
        top: 7px;
        width: 33px;
    }

    .msg_history {
        max-height: 300px;
        overflow-y: auto;
    }
</style>
